import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table
const ClientSitesList = ({ tableData,handleFilterSort, filtersort, filterorder }) => {

    // const tableData = [
    //     {
    //         "trading_name": "Rijul Test Client ",
    //         "clientOrgSites": [
    //             {
    //                 "site_id": "60",
    //                 "site_name": "test",
    //                 "site_address": "test",
    //                 "site_address_other": "test",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "00",
    //                 "site_zipcode": "289909",
    //                 "created_date": "2025-02-06T04:52:02.698Z",
    //                 "induction_count": "1",
    //                 "site_state": {
    //                     "state_name": "Northland Region"
    //                 }
    //             }
    //         ]
    //     },
    //     {
    //         "trading_name": "Client dikonia",
    //         "clientOrgSites": [
    //             {
    //                 "site_id": "63",
    //                 "site_name": "Boat",
    //                 "site_address": "tes",
    //                 "site_address_other": "re",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "45",
    //                 "site_zipcode": "160055",
    //                 "created_date": "2025-02-06T11:32:04.148Z",
    //                 "induction_count": "2",
    //                 "site_state": {
    //                     "state_name": "Bay of Plenty Region"
    //                 }
    //             },
    //             {
    //                 "site_id": "61",
    //                 "site_name": "One PK",
    //                 "site_address": "test",
    //                 "site_address_other": "test",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "53",
    //                 "site_zipcode": "213553",
    //                 "created_date": "2025-02-06T07:29:05.544Z",
    //                 "induction_count": "1",
    //                 "site_state": {
    //                     "state_name": "Tasman District"
    //                 }
    //             },
    //             {
    //                 "site_id": "57",
    //                 "site_name": "First site",
    //                 "site_address": "test",
    //                 "site_address_other": "test",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "16",
    //                 "site_zipcode": "160055",
    //                 "created_date": "2025-02-05T11:43:37.992Z",
    //                 "induction_count": "2",
    //                 "site_state": {
    //                     "state_name": "Gisborne District"
    //                 }
    //             },
    //             {
    //                 "site_id": "62",
    //                 "site_name": "Scan QR Code",
    //                 "site_address": "test",
    //                 "site_address_other": "test",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "46",
    //                 "site_zipcode": "160055",
    //                 "created_date": "2025-02-06T09:27:58.703Z",
    //                 "induction_count": "2",
    //                 "site_state": {
    //                     "state_name": "Gisborne District"
    //                 }
    //             },
    //             {
    //                 "site_id": "58",
    //                 "site_name": "Second Site",
    //                 "site_address": "test",
    //                 "site_address_other": "test",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "16",
    //                 "site_zipcode": "160045",
    //                 "created_date": "2025-02-05T12:15:58.173Z",
    //                 "induction_count": "3",
    //                 "site_state": {
    //                     "state_name": "Waikato Region"
    //                 }
    //             },
    //             {
    //                 "site_id": "59",
    //                 "site_name": "Oppo ",
    //                 "site_address": "Testes",
    //                 "site_address_other": "testtes",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "45",
    //                 "site_zipcode": "160055",
    //                 "created_date": "2025-02-05T12:16:59.601Z",
    //                 "induction_count": "1",
    //                 "site_state": {
    //                     "state_name": "Victoria"
    //                 }
    //             }
    //         ]
    //     },
    //     {
    //         "trading_name": "Acorn Crafts",
    //         "clientOrgSites": [
    //             {
    //                 "site_id": "64",
    //                 "site_name": "test",
    //                 "site_address": "test",
    //                 "site_address_other": "test",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "22",
    //                 "site_zipcode": "1312341",
    //                 "created_date": "2025-02-20T13:09:16.730Z",
    //                 "induction_count": "1",
    //                 "site_state": {
    //                     "state_name": "Taranaki Region"
    //                 }
    //             },
    //             {
    //                 "site_id": "66",
    //                 "site_name": "adf",
    //                 "site_address": "wer",
    //                 "site_address_other": "wer",
    //                 "is_site_active": true,
    //                 "induction_valid_days": "34",
    //                 "site_zipcode": "5346",
    //                 "created_date": "2025-02-21T12:57:02.886Z",
    //                 "induction_count": "0",
    //                 "site_state": {
    //                     "state_name": "Queensland"
    //                 }
    //             }
    //         ]
    //     }
    // ];
    return (
        <React.Fragment>
            <div className="overflow-hidden border rounded-lg border-gray-200">
                <Table>
                    <THead>
                        <Tr>
                            <Th>
                                <span className='flex items-center gap-1'>
                                    Client
                                </span>
                            </Th>
                            <Th>Site</Th>
                            <Th>Address</Th>
                            <Th>State</Th>
                            <Th>Status</Th>
                            <Th>Inductions</Th>
                            <Th>Valid days</Th>
                            <Th onClick={(e) => handleFilterSort(e, 'created_date_range')}>
                                <span className='flex items-center gap-1'>
                                    Publish date
                                    <svg className={`transform ${filtersort === "created_date_range" &&
                                        filterorder === "asc"
                                        ? "rotate-180"
                                        : ""
                                        }`} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8" stroke="#475467" stroke-width="1.333" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </Th>
                        </Tr>
                    </THead>
                    <TBody>
                        {tableData.map((client) =>
                            client.clientOrgSites.map((site) => (
                                <Tr key={site.site_id}>
                                    <Td>{client.trading_name}</Td>
                                    <Td>{site.site_name}</Td>
                                    <Td>{site.site_address}</Td>
                                    <Td>{site.site_state.state_name}</Td>
                                    <Td>{site.is_site_active ? "Active" : "Inactive"}</Td>
                                    <Td>{site.induction_count}</Td>
                                    <Td>{site.induction_valid_days}</Td>
                                    <Td>{new Date(site.created_date).toLocaleDateString()}</Td>
                                </Tr>
                            ))
                        )}
                    </TBody>
                </Table>
            </div>
        </React.Fragment>
    )
}
export default ClientSitesList;